export const FirebaseConfig = {
	"projectId": "ma-goods",
	"appId": "1:975841088476:web:6285d686b7852a12c3b519",
	"databaseURL": "https://ma-goods-default-rtdb.firebaseio.com",
	"storageBucket": "ma-goods.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCV3wm06kWiM5rebf8ZalxFjjQI0-I0hPM",
	"authDomain": "ma-goods.firebaseapp.com",
	"messagingSenderId": "975841088476",
	"measurementId": "G-8MJ91RVWCS"
};